// Bot Account Configuration
// This bot account creates topic root events
// All user entries (including first) are replies to bot's topic

export const BOT_CONFIG = {
    // IMPORTANT: Store nsec in environment variable in production!
    // For now, using a generated keypair
    // TODO: Move to .env before deployment

    name: 'Mavililer Sözlük',
    displayName: 'Mavililer Sözlük',
    about: '🇹🇷 Türkiye\'nin ilk Nostr tabanlı sözlüğü | Özgür düşünce platformu | sozluk.mavililer.com',
    picture: 'https://sozluk.mavililer.com/img/icon.png',
    website: 'https://sozluk.mavililer.com',
    nip05: 'sozluk@mavililer.com',

    // Bot keypair
    nsec: 'nsec1z03qk3cx8kpa7lpa5c9nzqaravcpxfnv4ngtmwe395xxckhwq4qsu2wyge',
    npub: 'npub1suacntqasqsveccjjhx9ffsjm0qrcv9c6eatde8qdt5syfqfyp4s4l0clw',
    pubkeyHex: '873b89ac1d8020cce31295cc54a612dbc03c30b8d67ab6e4e06ae9022409206b', // For filtering
}

// Helper to get bot secret key from nsec
export function getBotSecretKey(): Uint8Array | null {
    if (!BOT_CONFIG.nsec) {
        console.warn('Bot nsec not configured')
        return null
    }

    try {
        const { nip19 } = require('nostr-tools')
        const { data } = nip19.decode(BOT_CONFIG.nsec)
        return data as Uint8Array
    } catch (e) {
        console.error('Failed to decode bot nsec:', e)
        return null
    }
}

// Helper to get bot public key
export function getBotPublicKey(): string | null {
    if (!BOT_CONFIG.npub) {
        console.warn('Bot npub not configured')
        return null
    }

    try {
        const { nip19 } = require('nostr-tools')
        const { data } = nip19.decode(BOT_CONFIG.npub)
        return data as string
    } catch (e) {
        console.error('Failed to decode bot npub:', e)
        return null
    }
}
